var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('the-header-mobile'),_c('div',{staticClass:"mobile-body"},[_c('keep-alive',[_c('router-view',{key:_vm.$route.name})],1)],1),_c('call-menu-tabs-mobile'),_c('call-modal-logout',{model:{value:(_vm.dataModalLogout),callback:function ($$v) {_vm.dataModalLogout=$$v},expression:"dataModalLogout"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }